import { ConfigAction } from './ConfigAction';
export default ConfigAction;
